


























import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util';
import pagelist from '@/components/pagelistcomponent';
import AbpBase from '@/lib/abpbase';
import * as proxy from '@/lib/service-proxies/service-proxies';
import AppConsts from '@/lib/appconst';
import PagedFilterAndSortedRequest from '@/store/entities/page-request';
@Component
export default class systemsetting extends pagelist {
  get autoTradeproxy() {
    return new proxy.ClearSettingServiceProxy();
  }
  model: proxy.ClearSettingDto = new proxy.ClearSettingDto();
  platfroms = [];
  getpage() {
    this.autoTradeproxy.queryModel().then(x => {
      this.model = x;
    });
  }
  async created() {
    this.getpage();
  }
  save() {
    this.autoTradeproxy.save(this.model).then(() => {
      this.getpage();
      this.$Notice.success({ title: '保存成功' });
    });
  }
}
